var _path, _path2, _circle, _circle2, _rect, _circle3, _path3, _path4, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5C20.8284 2.5 21.5 3.17157 21.5 4V6.5H15.7383L17.3379 2.5H20Z",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 0.5C21.2186 1.64114 20.2095 2.5 19 2.5H17.6699L17.54 2.80273L14.6699 9.5H12.0625L1.58203 6.87988C1.23541 6.79294 1.08924 6.38069 1.30371 6.09473L2.7998 4.09961C3.08309 3.722 3.52793 3.5 4 3.5H13.4648C13.9664 3.49999 14.4347 3.24932 14.7129 2.83203L16.2676 0.5H21.4502Z",
    fill: "#F2C94C",
    stroke: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 9.99999,
    r: 3.99999,
    fill: "#333333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99999,
    cy: 9.99999,
    r: 3.99999,
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 6,
    height: 2,
    fill: "#333333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 2,
    fill: "#F2C94C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H22C22.5523 6 23 6.44772 23 7V8H18V6Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7H23V11H21V7Z",
    fill: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 10,
    r: 2,
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialIcon);
export default __webpack_public_path__ + "static/media/special-icon.ef41214dc31d9eec55c6a3fc17a61bf3.svg";
export { ForwardRef as ReactComponent };